module.exports = __webpack_public_path__ + "img/Flag_of_Montserrat.c78dc29e.svg";